import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center bg-white px-6 py-24 md:py-32 overflow-hidden" data-id="element-17">
      <div className="max-w-5xl mx-auto text-center z-10" data-id="element-18">
        <FadeIn delay={0.1} data-id="element-19">
          <span className="inline-block py-1 px-3 rounded-full bg-neutral-100 text-neutral-600 text-sm font-medium mb-8 tracking-wide" data-id="element-20">
            Stasis Studio
          </span>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-21">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-neutral-900 mb-8 leading-[1.1]" data-id="element-22">
            Build software in <br className="hidden md:block" data-id="element-23" />
            <span className="text-neutral-400" data-id="element-24">milestones.</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-25">
          <p className="text-l md:text-xl text-neutral-600 max-w-2xl mx-auto mb-12 font-light leading-relaxed" data-id="element-26">
            A proof-based web and software studio for South African businesses.
            Pay only when each stage is approved. No hourly billing. No
            surprises.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-27">
          <Button variant="primary" icon data-id="element-28">
            Start your project brief
          </Button>
          <Button variant="secondary" data-id="element-29">See how it works</Button>
        </FadeIn>
      </div>

      {/* Subtle background element */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-30">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-neutral-50 rounded-full blur-3xl opacity-60" data-id="element-31" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[600px] h-[600px] bg-neutral-50 rounded-full blur-3xl opacity-60" data-id="element-32" />
      </div>
    </section>;
}